/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LeftBuccalWithRetractors/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LeftBuccalWithRetractors({
  children,
  viewPath = "/DesignSystem/Images/LeftBuccalWithRetractors",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 286,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 274
  
}) {
  return (<React.Fragment
>
<img
  data-testid="LeftBuccalWithRetractors.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-1v1n5V': alignSelf,'--bc-2-1v1n5V': backgroundColor,'--bblr-3-1v1n5V': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-1v1n5V': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-1v1n5V': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-1v1n5V': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-1v1n5V': typeof height === 'number' ? `${height}px` : height,'--mb-8-1v1n5V': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-1v1n5V': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-1v1n5V': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-1v1n5V': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-1v1n5V': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}